<template>
  <div>
    <v-autocomplete
      v-model="selecionados"
      :items="items"
      item-text="razao_social"
      item-value="idfornecedor"
      multiple
      hide-selected
      outlined
      clearable
      height="10"
      return-object
      hide-details
      placeholder="Lista de Fornecedores"
      :error="selecionados.length === 0"
    >
      <template v-slot:selection>
        <!-- NADA -->
      </template>

      <template v-slot:prepend-item>
        <v-list-item class="sys-item-prepended-list px-3 py-2" @click="selecionarTodos()">
          <template v-if="selecionados.length === items.length">
            <v-icon color="primary">mdi-checkbox-marked</v-icon>
            <span class="subtitle-1 ml-3">Desmarcar todos</span>
          </template>
          <template v-else>
            <v-icon v-if="!selecionados.length">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
            <span class="subtitle-1 ml-3">Selecionar todos</span>
          </template>
        </v-list-item>

        <v-divider />
      </template>

      <template v-slot:prepend-inner v-if="selecionados.length > 0">
        <v-chip class="mt-n1 txt-row">
          {{ `${qtdeSelecionados} Fornecedor${selecionados.length > 1 ? 'es' : ''} selecionado${selecionados.length > 1 ? 's' : ''}` }}
        </v-chip>
      </template>
    </v-autocomplete>

    <div id="itens-selecionados">
      <v-list dense>
        <v-subheader>
          {{ selecionados.length > 0 ? 'Fornecedores selecionados' : 'Selecione um ou mais Fornecedores' }}
        </v-subheader>

        <template v-for="(item, index) in selecionados">
          <v-list-item :key="index">
            <v-list-item-action title="Desmacar" class="ml-n3">
              <v-btn icon color="primary" @click="removerItem(item)">
                <v-icon>mdi-checkbox-marked</v-icon>
              </v-btn>
            </v-list-item-action>

            <v-list-item-title v-text="item.razao_social"></v-list-item-title >

            <v-btn icon @click="removerItem(item)" title="Desmacar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item>

          <v-divider
            v-if="index < selecionados.length - 1"
            :key="`${index}_`"
          ></v-divider>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "autoCompleteFornecedor",
  props: {
    items: {
      type: Array,
      required: true
    },
    autoSelecionarTodos: {
      type: Boolean,
      required: false
    }
  },
  data: () => ({
    selecionados: []
  }),
  computed: {
    qtdeSelecionados () {
      if (!this.selecionados.length) {
        return 0
      }

      if (this.selecionados.length === this.items.length) {
        return 'Todos'
      }

      return this.selecionados.length
    }
  },
  created() {
    this.selecionados = []
    this.selecionarTodos(true)
  },
  watch: {
    selecionados (values) {
      this.$emit('change', this.Helpers.arrayColumn(values, 'idfornecedor'))
    },
    autoSelecionarTodos () {
      if (this.autoSelecionarTodos) {
        this.selecionados = []
        this.selecionarTodos(true)
      }
    },
    items () {
      this.items.length > 0 && this.selecionarTodos(true)
    }
  },
  methods: {
    removerItem (item) {
      this.selecionados = this.selecionados.filter(forn => forn.idfornecedor != item.idfornecedor)
    },
    selecionarTodos (force = false) {
      if (this.selecionados.length > 0 && this.selecionados.length === this.items.length && !force) {
        this.selecionados = []
      } else {
        this.selecionados = this.items
      }
    }
  }
}
</script>

<style scoped>
.txt-row {
  white-space: nowrap
}
#itens-selecionados {
  border-left: 1px solid rgba(0,0,0,.1);
  border-right: 1px solid rgba(0,0,0,.1);
  height: calc(100vh - 135px);
  overflow-y: auto;
}
</style>
